import { getRemovebgLogs } from '../../thunk/removebgLogs';

export default (builder) => {
    builder
        .addCase(getRemovebgLogs.pending, (state) => {
            console.log('RemovebgLogs: Loading...');
            state.status = 'loading';
            state.error = null;
        })
        .addCase(getRemovebgLogs.fulfilled, (state, action) => {
            console.log('RemovebgLogs: Success, data:', action.payload);
            state.status = 'succeeded';
            state.data = action.payload;
            state.error = null;
            
            // Оновлюємо тільки page і limit з відповіді API, зберігаючи всі інші параметри
            if (action.payload) {
                state.queryParams = {
                    ...state.queryParams,
                    page: action.payload.page || state.queryParams.page || 1,
                    limit: action.payload.perPage || state.queryParams.limit || 100
                };
            }
        })
        .addCase(getRemovebgLogs.rejected, (state, action) => {
            console.log('RemovebgLogs: Failed, error:', action.payload);
            state.status = 'failed';
            state.error = action.payload;
        });
}; 